	export enum ImmMidEarEvalTympEnum {
		A = 1,
		As = 2,
		B = 3,
		C = 4,
		Ad = 5,
		Perf_PPET = 6,
		INC = 7
	}
